import { ACTION_TYPE } from '../core/redux/actionType';
import { IAppState } from '../core/redux/IAppState';
import { Action } from 'redux';
import { assoc } from '../language/module';


/**
 * Makes an action you can dispatch to clear out the training document list in app state.
 */
export const clearTrainingDocumentsAction = () => ({
  type: ACTION_TYPE.CLEAR_TRAINING_DOCS,
});


export const clearTrainingDocumentsReducer = (
  state: IAppState,
  action: Action,
): IAppState => action.type !== ACTION_TYPE.CLEAR_TRAINING_DOCS ? state : assoc('trainingDocuments', undefined, state);
